import { SHOP_ROOT, SHOP_ALL_PRODUCTS } from '~/utils/categoryRoutes'

export function useCategoryUrl () {
  // The root shop path
  const shopRootPath = computed(() => SHOP_ROOT)

  const buildCategoryUrl = (slug: string | undefined) => {
    if (!slug) { return '' }
    // All Products is a duplicate of /shop-products — redirect to the parent
    if (slug === SHOP_ALL_PRODUCTS) { return SHOP_ROOT }
    return slug
  }

  return {
    shopRootPath,
    buildCategoryUrl
  }
}
